(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════
     РОЗМІРНІ СІТКИ — єдине місце редагування
     Джерело: ТЗ 1 · 1 вересня 2026
     ═══════════════════════════════════════════════════ */
  var SIZE_DATA = {
    /* обхват під грудьми, см → число розміру */
    band: [
      { size: '70', range: [68, 72] },
      { size: '75', range: [73, 77] },
      { size: '80', range: [78, 82] }
    ],
    /* груди мінус під грудьми, см → літера чашки */
    cup: [
      { size: 'A', range: [10, 12] },
      { size: 'B', range: [13, 14] },
      { size: 'C', range: [15, 16] },
      { size: 'D', range: [17, 18] }
    ],
        /* низ: талія й стегна – рівноправні мірки, кожна дає свій розмір */
    bottom: [
      { size: 'XS', waist: [0, 62],  hips: [0, 90]    },
      { size: 'S',  waist: [63, 66], hips: [91, 96]   },
      { size: 'M',  waist: [67, 70], hips: [97, 102]  },
      { size: 'L',  waist: [71, 74], hips: [103, 108] },
      { size: 'XL', waist: [75, 78], hips: [109, 114] }
    ]
  };

  var UNAVAILABLE = 'На жаль, виробу в цьому розмірі нині немає в наявності. Зв\u02BCяжіться з нами – і ми обов\u02BCязково це вирішимо.';

  /* ═══ Модальні вікна ═══ */

  var openPanel = null;
  var lastFocus = null;

  function open(panel) {
    if (openPanel) close();
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.body.classList.add('re-size-lock');
    openPanel = panel;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    var c = panel.querySelector('.re-size-modal__close');
    if (c) c.focus();
  }

  function close() {
    if (!openPanel) return;
    var panel = openPanel;
    openPanel = null;
    panel.classList.remove('is-open');
    document.body.classList.remove('re-size-lock');
    window.setTimeout(function () { panel.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) close();
  });

  /* ═══ Розрахунок ═══ */

  function inRange(v, r) { return v >= r[0] && v <= r[1]; }

  function calcTop(underbust, bust) {
    var band = null, i;
    for (i = 0; i < SIZE_DATA.band.length; i++) {
      if (inRange(underbust, SIZE_DATA.band[i].range)) { band = SIZE_DATA.band[i].size; break; }
    }
    if (band === null) return null;

    var diff = bust - underbust;
    var cup = null;
    for (i = 0; i < SIZE_DATA.cup.length; i++) {
      if (inRange(diff, SIZE_DATA.cup[i].range)) { cup = SIZE_DATA.cup[i].size; break; }
    }
    if (cup === null) return null;

    return band + cup;
  }

  function calcBottom(waist, hips) {
    var wi = -1, hi = -1, i;

    /* талія дає перший розмір */
    for (i = 0; i < SIZE_DATA.bottom.length; i++) {
      if (inRange(waist, SIZE_DATA.bottom[i].waist)) { wi = i; break; }
    }
    /* стегна дають другий розмір */
    for (i = 0; i < SIZE_DATA.bottom.length; i++) {
      if (inRange(hips, SIZE_DATA.bottom[i].hips)) { hi = i; break; }
    }
    if (wi < 0 || hi < 0) return null;

    /* результат – більший із двох */
    return SIZE_DATA.bottom[Math.max(wi, hi)].size;
  }

  /* ═══ Ініціалізація ═══ */

  function init() {
    var root = document.querySelector('[data-re-size-root]');
    if (!root) return;

    /* виносимо попапи в body — щоб не залежати від stacking context теми */
    var panels = root.querySelectorAll('.re-size-modal');
    Array.prototype.forEach.call(panels, function (p) { document.body.appendChild(p); });

    document.addEventListener('click', function (e) {
      var node = e.target;
      if (node && node.nodeType !== 1) node = node.parentElement;
      if (!node || !node.closest) return;

      var opener = node.closest('[data-re-size-open]');
      if (opener) {
        e.preventDefault();
        var target = document.getElementById(opener.getAttribute('data-re-size-open'));
        if (target) open(target);
        return;
      }

      if (node.closest('[data-re-size-close]')) {
        e.preventDefault();
        close();
        return;
      }

      /* клік усередині відкритого модала, але поза панеллю — закриваємо */
      if (openPanel && node.closest('.re-size-modal') === openPanel && !node.closest('.re-size-modal__panel')) {
        close();
      }
    });

    var calc = document.getElementById('re-size-calc');
    if (!calc) return;

    /* Нормалізація: у даних Shopify трапляються кириличні А, В, С, Е, М, Х —
       візуально не відрізнити від латинських, але для порівняння це різні символи */
    var CYR_TO_LAT = { 'А':'A', 'В':'B', 'С':'C', 'Е':'E', 'М':'M', 'Х':'X', 'Р':'P', 'К':'K', 'О':'O', 'Т':'T', 'Н':'H' };

    function norm(s) {
      return String(s).toUpperCase().replace(/[А-ЯЁІЇЄҐ]/g, function (ch) {
        return CYR_TO_LAT[ch] || ch;
      });
    }

    var topList    = (calc.getAttribute('data-top-sizes')    || '').split('|').filter(Boolean).map(norm);
    var bottomList = (calc.getAttribute('data-bottom-sizes') || '').split('|').filter(Boolean).map(norm);
    var hasTop     = calc.getAttribute('data-has-top') === '1';
    var hasBottom  = calc.getAttribute('data-has-bottom') === '1';

    var fields = {
      underbust: document.getElementById('re-underbust'),
      bust:      document.getElementById('re-bust'),
      waist:     document.getElementById('re-waist'),
      hips:      document.getElementById('re-hips')
    };
    var rowTop     = document.getElementById('re-row-top');
    var rowBottom  = document.getElementById('re-row-bottom');
    var valTop     = document.getElementById('re-val-top');
    var valBottom  = document.getElementById('re-val-bottom');
    var resultWrap = document.getElementById('re-result');
    var note       = document.getElementById('re-note');

    function num(el) {
      if (!el) return null;
      var v = parseFloat(el.value);
      return isNaN(v) ? null : Math.round(v);
    }

    function render(row, valEl, size, available) {
      var ok = size !== null && available;
      row.hidden = false;
      row.classList.toggle('is-missing', !ok);
      valEl.textContent = ok ? size : '–';
      return ok;
    }

    function update() {
      var ub = num(fields.underbust);
      var b  = num(fields.bust);
      var w  = num(fields.waist);
      var h  = num(fields.hips);

      var topDone    = ub !== null && b !== null;
      var bottomDone = w !== null && h !== null;
      var problem = false;

      if (topDone) {
        var ts = calcTop(ub, b);
        var tAvail = ts !== null && (!hasTop || topList.indexOf(norm(ts)) !== -1);
        if (!render(rowTop, valTop, ts, tAvail)) problem = true;
      } else {
        rowTop.hidden = true;
      }

      if (bottomDone) {
        var bs = calcBottom(w, h);
        var bAvail = bs !== null && (!hasBottom || bottomList.indexOf(norm(bs)) !== -1);
        if (!render(rowBottom, valBottom, bs, bAvail)) problem = true;
      } else {
        rowBottom.hidden = true;
      }

      var anyDone = topDone || bottomDone;
      resultWrap.hidden = !anyDone;
      note.hidden = !anyDone;
      note.textContent = problem ? UNAVAILABLE : 'Якщо ви між розмірами, беріть більший.';
      note.classList.toggle('is-warning', problem);
    }

    Object.keys(fields).forEach(function (k) {
      if (fields[k]) fields[k].addEventListener('input', update);
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();